import { Dialog, styled as muiStyled } from "@mui/material";

export const BlurredDialog = muiStyled(Dialog)(({theme})=>`
    .MuiDialog-container{
    backdrop-filter: blur(3px);
    }
`)